import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Alcool au volant : comment s'en sortir en 2025?"
            description="Nous vous expliquons comment éviter une condamnation de conduite avec les facultés affaiblies par l’alcool"
            fr={undefined}
            lawType="criminal"
            specialtyText="Alcool au volant  comment s'en sortir">
            <p>
                Bien que certaines conséquences de l’alcool au volant soit
                inévitable, vous pouvez tout de même éviter le pire. En
                démontrant que l’un de vos droits a été violé ou en soulevant un
                moyen de défense, vous pourriez être acquitté.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Alcool au volant et ses conséquences en 2025!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Vous souhaitez éviter les conséquences de l’alcool au volant
                    en 2025? Avocats Alcool au Volant est là pour vous!
                </strong>
            </p>
            <h2>
                <strong>
                    Qu’est-ce que la conduite avec facultés affaiblies par
                    l'alcool?
                </strong>
            </h2>
            <p>
                La conduite avec facultés affaiblies par l'alcool est une
                infraction qui se produit dans les deux situations suivantes :
            </p>
            <ul>
                <li>
                    La personne a conduit un moyen de transport alors que ses
                    capacités sont affaiblies à un quelconque degré par l’effet
                    de l’alcool ou d’une drogue ou par l’effet combiné de
                    l’alcool et d’une drogue;
                </li>
                <li>
                    La personne a, dans les 2 heures suivant le moment où elle a
                    cessé de conduire un moyen de transport, une taux d’alcool
                    d’au moins 80 mg par 100 ml de sang;
                </li>
            </ul>
            <p>
                Lorsqu’une personne consomme de l'alcool après avoir cessé de
                conduire et qu'elle n'avait pas de raison de croire qu'on lui
                demanderait de fournir un échantillon d'haleine ou de sang, elle
                ne peut être reconnue coupable de cette infraction.
            </p>
            <h3>
                <strong>
                    Quelles sont les conséquences d’une condamnation pour
                    conduite avec les facultés affaiblies par l’alcool?
                </strong>
            </h3>
            <p>
                Être reconnu coupable de conduite avec les facultés affaiblies
                par l’alcool entraîne de lourdes{' '}
                <Link to="https://avocatsalcoolauvolant.ca/consequences-alcool-volant/">
                    conséquences
                </Link>
                . Cette infraction, considérée comme un acte criminel au Canada,
                est sévèrement sanctionnée, avec des répercussions immédiates et
                à long terme.
            </p>
            <h4>
                <strong>Sanctions financières :</strong>
            </h4>
            <p>
                L’une des premières conséquences d’une condamnation est
                l’imposition d’une amende. Le montant minimal s’élève à 1 000 $,
                mais il peut augmenter selon le taux d’alcool au moment de
                l’infraction :
            </p>
            <table>
                <tr>
                    <td>
                        <p>Taux d’alcool (mg par 100 ml de sang)</p>
                    </td>
                    <td>
                        <p>Contravention minimale (2025)</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 80 et 119</p>
                    </td>
                    <td>
                        <p>1 000 $</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Entre 120 et 159</p>
                    </td>
                    <td>
                        <p>1 500 $</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>160 ou plus</p>
                    </td>
                    <td>
                        <p>2 000 $</p>
                    </td>
                </tr>
            </table>
            <h4>
                <strong>Casier judiciaire :</strong>
            </h4>
            <p>
                Une condamnation entraîne également une inscription au casier
                judiciaire. Cela peut nuire à plusieurs aspects de la vie du
                contrevenant, notamment:{' '}
            </p>
            <ul>
                <li>l’accès à l’emploi, </li>
                <li>les voyages à l’étranger, le bénévolat, </li>
                <li>la location d’un logement, ou </li>
                <li>les demandes de résidence permanente ou de citoyenneté.</li>
            </ul>
            <h4>
                <strong>Suspension du permis de conduire :</strong>
            </h4>
            <p>
                Dès l’arrestation, votre permis de conduire sera automatiquement
                suspendu. Le policier pourra suspendre votre permis pour 90
                jours, mais le juge pourra allonger la suspension.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Suspension de permis de conduire après alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Une personne dont le permis de conduire a été suspendu en raison
                d’une condamnation pour conduite avec les facultés affaiblies
                par l’alcool peut, dans certains cas, demander un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/garder-permis-alcool-volant/">
                    permis restreint
                </Link>{' '}
                lui autorisant d’effectuer des déplacements essentiels.
            </p>
            <h4>
                <strong>Peine d’emprisonnement:</strong>
            </h4>
            <p>
                Si vous avez un taux d’alcool supérieur au double de la limite
                permise ou s’il s’agit d’une deuxième infraction, vous pourriez
                avoir une peine d’emprisonnement qui peut aller jusqu’à 10 ans.
            </p>
            <p>
                Pour une première infraction, la peine d’emprisonnement est
                laissée à la discrétion du juge. En revanche, dès la deuxième
                infraction, l’emprisonnement est obligatoire.{' '}
            </p>
            <h4>
                <strong>Installation d’un dispositif antidémarrage:</strong>
            </h4>
            <p>
                Le tribunal peut ordonner l’installation d’un dispositif anti
                démarrage dans le véhicule du contrevenant. Ce système empêche
                le démarrage du véhicule si une concentration d’alcool est
                détectée dans l’haleine du conducteur.
            </p>
            <h4>
                <strong>
                    Participation à des programmes de sensibilisation:
                </strong>
            </h4>
            <p>
                Il est possible pour le tribunal d’ordonner la participation à
                des programmes de sensibilisation ou de réhabilitation. Des
                programmes comme Alcofrein ou le PERRCCA (Programme d’évaluation
                et de réduction du risque de conduite avec les capacités
                affaiblies) visent à prévenir les récidives en sensibilisant les
                participants aux dangers de l’alcool au volant.
            </p>
            <p>
                La participation à ces programmes entraîne des frais à la charge
                de la personne concernée:
            </p>
            <table>
                <tr>
                    <td>
                        <p>Programme</p>
                    </td>
                    <td>
                        <p>Coût (2025)</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Alcofrein</p>
                    </td>
                    <td>
                        <p>150,00 $</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>PERRCCA</p>
                    </td>
                    <td>
                        <p>351,00 $</p>
                    </td>
                </tr>
            </table>
            <p>
                Si la SAAQ demande une évaluation complète, les coûts vont
                s’élever à 830,70 $ plus taxes
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Programmes de sensibilisation pour alcool au volant"
                    alt=""
                />
            </p>
            <p>
                La conduite avec les facultés affaiblies par l’alcool est loin
                d’être une infraction mineure. Elle entraîne des sanctions
                juridiques, financières et sociales qui peuvent compromettre
                sérieusement l’avenir du contrevenant.{' '}
                <strong>
                    Éviter une condamnation de conduite avec les facultés
                    affaiblies par l’alcool avec l’aide d’un avocat spécialisé
                    en droit criminel!
                </strong>
            </p>
            <p>
                Être accusé de conduite avec les facultés affaiblies par
                l’alcool ne signifie pas automatiquement être reconnu coupable.
                Il est tout à fait possible d’être acquitté. C’est la personne
                qui poursuit qui doit faire la preuve hors de tout doute
                raisonnable.
            </p>
            <p>
                Lorsqu’un avocat de la défense présente un ou plusieurs moyens
                de défense, il peut soulever un doute raisonnable, ce qui mène à
                un acquittement. Bien qu’il soit permis de se représenter
                soi-même devant les tribunaux,{' '}
                <strong>
                    il est recommandé de faire appel à un avocat spécialisé en
                    droit criminel!
                </strong>
            </p>
            <p>
                Voici quelques moyens de défense qu’un avocat peut faire valoir
                devant le tribunal pour obtenir un acquittement :
            </p>
            <h3>
                <strong>
                    Soulever un doute raisonnable sur les capacités affaiblies{' '}
                </strong>
            </h3>
            <p>
                Une personne peut être reconnue coupable de conduite avec les
                facultés affaiblies de deux façons. L’une d’elles repose sur
                l’article 320.14 (1) a) du Code criminel :
            </p>
            <p>
                « La personne a conduit un moyen de transport alors que sa
                capacité de conduire était affaiblie, à quelque degré que ce
                soit, par l’effet de l’alcool, d’une drogue ou de la combinaison
                des deux. »
            </p>
            <p>
                Lorsque les accusations reposent sur l’article 320.14 (1) a), la
                Couronne s’appuie sur des preuves circonstancielles, constituées
                de plusieurs manifestations physiques observées chez le
                conducteur, telles que :
            </p>
            <ul>
                <li>L’allure générale</li>
                <li>Le comportement</li>
                <li>L’élocution, la coordination</li>
                <li>Etc.</li>
            </ul>
            <p>
                Il n’existe pas de liste exhaustive de symptômes permettant de
                conclure à un affaiblissement. Chaque situation doit être
                analysée dans son ensemble.
            </p>
            <p>
                Un avocat de la défense peut soutenir que ces comportements
                découlent d'autres facteurs : stress, fatigue, émotion intense
                ou distraction momentanée.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Défenses pour alcool au volant!"
                    alt=""
                />
            </p>
            <p>
                Par exemple, un résultat « FAIL » obtenu avec un appareil de
                détection approuvé (ADA) n’établit pas automatiquement une
                capacité affaiblie. Ce résultat indique la présence d’alcool et
                justifie la demande d’un échantillon d’haleine, mais ne prouve
                pas à lui seul un affaiblissement réel au moment de la conduite.
            </p>
            <h4>
                <strong>
                    Les efforts de l'avocat pour soulever un doute raisonnable
                </strong>
            </h4>
            <p>
                L’avocat cherchera donc à démontrer que les signes observés,
                tels que les yeux rouges, la démarche incertaine, la lenteur
                d’élocution, peuvent s’expliquer autrement que par la
                consommation d’alcool. Il pourra souligner toute imprécision
                dans les témoignages des policiers, l’absence de preuve vidéo,
                ou encore un délai significatif entre la conduite et les tests
                effectués.
            </p>
            <p>
                Son travail consiste à remettre en question le lien entre l’état
                du conducteur et l’alcool, et à proposer des explications
                plausibles et réalistes. Si ces explications suffisent à semer
                un doute raisonnable dans l’esprit du juge, l’accusé sera
                acquitté!
            </p>
            <h3>
                <strong>Erreur dans l’analyse de l’échantillon </strong>
                Lorsqu’une personne est accusée de conduite avec les facultés
                affaiblies par l’alcool, elle est présumée coupable si, dans les
                deux heures suivant la conduite, son taux d’alcool dans le sang
                atteint ou dépasse 80 mg pour 100 ml.
            </h3>
            <p>
                Un avocat spécialisé en droit criminel peut contester la
                validité de la preuve si le dépistage de l’alcoolémie n’a pas
                été effectué conformément aux normes rigoureuses prévues par la
                loi.
            </p>
            <p>
                Le Code criminel énonce des conditions précises à respecter pour
                que les résultats des analyses du taux d’alcool du conducteur
                bénéficient d’une présomption d’exactitude.
            </p>
            <p>Ces conditions incluent notamment les éléments suivants :</p>
            <ul>
                <li>
                    L’appareil a été manipulé par un technicien qualifié, dont
                    les certifications et la formation sont à jour au moment de
                    l’analyse ;
                </li>
                <li>
                    Avant chaque prélèvement, un test à blanc a été effectué
                    afin de s’assurer de l’absence d’alcool résiduel dans
                    l’éthylomètre, avec un seuil maximal de 10 mg d’alcool par
                    100 ml de sang ;
                </li>
                <li>
                    Un test d’étalonnage a démontré que l’appareil présentait un
                    écart d’au plus 10 % par rapport à une valeur cible
                    certifiée par un analyste ;
                </li>
                <li>
                    Les échantillons ont été prélevés à au moins 15 minutes
                    d’intervalle ;
                </li>
                <li>
                    Les résultats ont été arrondis à la dizaine inférieure et ne
                    présentaient pas d’écart supérieur à 20 mg d’alcool par 100
                    ml de sang entre les deux lectures.
                </li>
            </ul>
            <h4>
                <strong>
                    Les failles potentielles dans la procédure et le rôle clé de
                    l’avocat
                </strong>
            </h4>
            <p>
                Si l’une de ces conditions n’est pas respectée, la présomption
                d’exactitude du taux d’alcool du conducteur ne s’applique plus.
                Cela donne à l’avocat de la défense l’occasion de contester la
                fiabilité des résultats obtenus.
            </p>
            <p>
                Grâce à sa connaissance des exigences techniques et juridiques
                encadrant les analyses d’alcoolémie, il peut:{' '}
            </p>
            <ul>
                <li>Examiner minutieusement la procédure utilisée, </li>
                <li>Identifier les irrégularités, et </li>
                <li>
                    Mettre en lumière les failles dans la preuve de la Couronne.
                </li>
            </ul>
            <p>
                <Img
                    fluid={data.img4.childImageSharp.fluid}
                    title="Défense contre une mauvaise utilisation de l’alcootest!"
                    alt=""
                />
            </p>
            <p>
                En démontrant que certaines conditions essentielles n’ont pas
                été respectées, telles que:
            </p>
            <ul>
                <li>
                    <strong>La qualification du technicien : </strong>vérifier
                    que le technicien était dûment formé et certifié au moment
                    de l’analyse.
                </li>
                <li>
                    <strong>La conformité des tests préalables : </strong>
                    garantir qu’un test à blanc a été effectué et que
                    l’éthylomètre était exempt d’alcool résiduel.
                </li>
                <li>
                    <strong>La précision de l’éthylomètre : </strong>prouver que
                    l’appareil avait un écart de calibration n’excédant pas les
                    10 % autorisés.
                </li>
                <li>
                    <strong>
                        Le respect des délais entre les prélèvements :
                    </strong>{' '}
                    assurer que les échantillons ont été collectés à au moins 15
                    minutes d’intervalle.
                </li>
            </ul>
            <p>
                L’avocat peut faire valoir qu’un doute raisonnable subsiste
                quant au taux réel d’alcool dans le sang de l’accusé au moment
                des faits. Ainsi, même si le taux mesuré dépasse la limite
                légale, le non-respect des procédures imposées par le Code
                criminel peut constituer un moyen de défense permettant
                d’obtenir un acquittement.
            </p>
            <h3>
                <strong>
                    Les droits constitutionnels de l’accusé ont été violés
                </strong>
            </h3>
            <p>
                Lorsqu’une personne est arrêtée pour conduite avec les facultés
                affaiblies, elle possède des droits fondamentaux garantis par la
                Charte canadienne. Ces garanties constitutionnelles, qui
                assurent un traitement juste et équitable, doivent être
                obligatoirement respectées par les policiers.
            </p>
            <p>
                L’avocat est en mesure d’examiner les faits et de déterminer si
                des atteintes aux droits fondamentaux de l’accusé ont été
                commises. Si un ou plusieurs droits de l’accusé sont enfreints,
                l’avocat de la défense peut faire valoir ces violations devant
                le tribunal afin d’obtenir une réparation.
            </p>
            <p>
                Deux recours peuvent être entrepris par l’avocat en cas de
                violation des droits constitutionnels de l’accusé :
            </p>
            <ul>
                <li>Déposer une requête en exclusion de la preuve.</li>
                <li>
                    Présenter une requête en arrêt des procédures judiciaires.
                </li>
            </ul>
            <table>
                <tr>
                    <td>
                        <p>Requête de la charte</p>
                    </td>
                    <td>
                        <p>Explication</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Exclusion des éléments de preuve</p>
                    </td>
                    <td>
                        <p>
                            Permet de contester la recevabilité des éléments de
                            preuve obtenus en contravention des droits de
                            l’accusé. En démontrant que des éléments de preuves
                            ont été obtenus en violation de la Charte, l’avocat
                            peut convaincre le juge de les écarter du procès.
                        </p>
                        <p>
                            L’exclusion d’une preuve essentielle peut affaiblir
                            considérablement le dossier de la Couronne. Dans
                            certains cas, cela empêche même la Couronne de
                            prouver la culpabilité de l’accusé au-delà de tout
                            doute raisonnable, menant directement à un verdict
                            d’acquittement.
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Arrêt des procédures judiciaires</p>
                    </td>
                    <td>
                        <p>
                            Une requête en arrêt des procédures judiciaires est
                            généralement déposée lorsqu’une violation des droits
                            constitutionnels est jugée particulièrement grave.
                            Cette mesure exceptionnelle s’applique dans les cas
                            où l’exclusion de la preuve ne suffit pas à
                            compenser l’atteinte subie par l’accusé.
                        </p>
                        <p>
                            Si le tribunal estime que cette violation compromet
                            l’intégrité du système judiciaire et qu’aucune autre
                            réparation n’est envisageable, il peut alors décider
                            de prononcer l’arrêt des procédures. Une telle
                            décision équivaut à un acquittement!
                        </p>
                    </td>
                </tr>
            </table>
            <p>
                Voici 3 violations fréquemment observées dans les cas de
                conduite avec facultés affaiblies par l’alcool, qui peuvent
                justifier une requête en exclusion de preuve ou une requête en
                arrêt de procédure :
            </p>
            <h4>
                <strong>1) Le droit à l’assistance d’un avocat</strong>
            </h4>
            <p>
                La Charte protège le droit de consulter un avocat immédiatement
                après une arrestation. Ce droit vise à assurer qu’un individu
                détenu puisse comprendre ses droits, obtenir des conseils
                juridiques éclairés et éviter de s’auto-incriminer par ignorance
                ou sous pression.
            </p>
            <p>
                Lorsqu’une personne est arrêtée pour conduite avec facultés
                affaiblies par l’alcool, les policiers ont l’obligation :
            </p>
            <ul>
                <li>
                    De l’informer clairement de son droit de consulter un
                    avocat,
                </li>
                <li>
                    De lui offrir l’occasion raisonnable d’exercer ce droit,
                </li>
                <li>
                    Et de s’abstenir de poser des questions jusqu’à ce que cette
                    consultation ait eu lieu.
                </li>
            </ul>
            <p>
                <Img
                    fluid={data.img5.childImageSharp.fluid}
                    title="Obligation des policiers d’informer sur le droit à un avocat!"
                    alt=""
                />
            </p>
            <p>
                Si la police interroge une personne ou procède à des tests,
                comme un alcootest, sans l’avoir informée de son droit de
                consulter un avocat ou sans lui avoir donné la possibilité
                d’exercer ce droit, l’avocat de la défense peut déposer une
                requête en exclusion de la preuve afin que les résultats obtenus
                soient jugés inadmissibles en preuve.
            </p>
            <h4>
                <strong>
                    2) Le droit d’être informé des motifs de l’arrestation
                </strong>
            </h4>
            <p>
                Un autre droit fondamental est celui de connaître immédiatement
                les motifs de son arrestation. La Charte stipule que toute
                personne arrêtée doit être informée, dans un langage clair et
                accessible, des raisons pour lesquelles elle est privée de sa
                liberté.
            </p>
            <ul>
                <li>
                    Il ne suffit donc pas de dire à une personne qu’elle est
                    arrêtée : les policiers doivent lui expliquer de manière
                    compréhensible qu’elle est arrêtée pour conduite avec les
                    facultés affaiblies.
                </li>
            </ul>
            <p>
                L’omission de fournir ces informations peut compromettre la
                capacité de l’accusé à exercer d’autres droits fondamentaux,
                notamment celui de consulter un avocat.
            </p>
            <p>
                Lorsqu’un tel manquement survient, l’avocat de la défense peut
                présenter une requête en exclusion de la preuve afin que soient
                écartés tous les éléments obtenus par la police alors que
                l’accusé ne savait pas clairement qu’il était arrêté pour
                conduite avec les facultés affaiblies par l’alcool.
            </p>
            <h4>
                <strong>
                    3) Le droit à un procès dans un délai raisonnable
                </strong>
            </h4>
            <p>
                Le droit d'être jugé dans un délai raisonnable est garanti par
                la Charte. Ce droit vise à protéger les accusés contre les
                délais excessifs dans le système judiciaire, qui peuvent
                compromettre leur capacité à se défendre efficacement.
            </p>
            <p>Les tribunaux ont établis les délais suivants:</p>
            <ul>
                <li>18 mois suivant le dépôt des accusations, et</li>
                <li>
                    30 mois pour les procès devant la cour supérieure ou les
                    procédures impliquant une enquête préliminaire.{' '}
                </li>
            </ul>
            <p>
                Si le procès dépasse ces délais sans justification valable,
                l’avocat de la défense peut demander l'arrêt des procédures.
                L’avocat devra démontrer que les retards sont déraisonnables et
                qu'ils ne sont pas dus à des manœuvres dilatoires et
                intentionnelles de la part de l'accusé.
            </p>
            <p>
                Si le tribunal conclut que les délais ont porté atteinte aux
                droits constitutionnels de l'accusé, il peut ordonner l'arrêt
                des procédures, équivalent à un acquittement.
            </p>
            <p>
                Bref, dans les affaires de conduite avec facultés affaiblies, le
                rôle de l’avocat ne se limite pas à plaider l’innocence de son
                client. Il consiste aussi, et surtout, à veiller au respect
                scrupuleux des droits fondamentaux de celui-ci, à scruter chaque
                étape de l’arrestation, de l’enquête policière et de la
                procédure judiciaire, et à utiliser tout manquement pour obtenir
                un acquittement.
            </p>
            <h2>
                <strong>
                    Vous êtes accusé de conduite avec les facultés affaiblies
                    par l’alcool? Consultez un avocat spécialisé en droit
                    criminel !
                </strong>
            </h2>
            <p>
                Recourir à un avocat compétent dans le domaine garantit une
                défense rigoureuse, capable d’examiner toutes les facettes de
                votre dossier. Selon les circonstances, cette assistance peut
                même aboutir à un acquittement.
            </p>
            <p>
                <Img
                    fluid={data.img6.childImageSharp.fluid}
                    title="Avocat pour être acquitté d’alcool au volant en 2025!"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    Grâce à notre formulaire simple et gratuit, vous serez en
                    mesure de trouver rapidement un avocat spécialisé en droit
                    criminel !
                </strong>
            </p>
            <p>
                <strong>
                    Suite à votre demande, nous vous mettrons rapidement en
                    contact avec un avocat criminaliste près de chez vous. Ce
                    processus ne nécessite aucun engagement de votre part !
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "alcool-volant-eviter-condamnation/alcool-volant-consequences-2025.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "alcool-volant-eviter-condamnation/suspension-permis-conduire-alcool.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "alcool-volant-eviter-condamnation/programmes-sensibilisation-alcool-volant-2025.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "alcool-volant-eviter-condamnation/defenses-alcool-volant-2025.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img4: file(
            relativePath: {
                eq: "alcool-volant-eviter-condamnation/defenses-mauvaise-utilisation-alcootest.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img5: file(
            relativePath: {
                eq: "alcool-volant-eviter-condamnation/obligation-policier-informer-droit-avocat.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img6: file(
            relativePath: {
                eq: "alcool-volant-eviter-condamnation/avocat-acquittement-alcool-volant-2025.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
